import React from 'react';

const TermsPage = () => {
  return (
    <div className="bg-background text-on-surface font-body antialiased min-h-screen pt-24 pb-20">
      <main className="max-w-4xl mx-auto px-8">
        <header className="mb-16">
          <h1 className="text-4xl md:text-5xl font-extrabold tracking-tighter mb-4 font-headline">Terms of Service</h1>
          <p className="text-on-surface-variant italic">Last updated: April 2024</p>
        </header>

        <div className="prose prose-emerald max-w-none text-on-surface-variant leading-relaxed space-y-10">
          <section>
            <h2 className="text-2xl font-bold text-on-surface mb-4">1. Acceptance of Terms</h2>
            <p>By accessing or using Local Advisor, you agree to be bound by these Terms of Service and all applicable laws and regulations.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-on-surface mb-4">2. Use of Service</h2>
            <p>You may use our service only for lawful purposes and in accordance with these Terms. You are responsible for any content you post to the community boards.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-on-surface mb-4">3. Content Moderation</h2>
            <p>We reserve the right to remove any content that violates our community guidelines or is deemed inappropriate for the Local Advisor platform.</p>
          </section>

          <section className="bg-surface-container-low p-10 rounded-2xl border border-outline-variant/10">
            <h2 className="text-xl font-bold text-on-surface mb-4">Community Guidelines</h2>
            <p className="text-sm italic leading-relaxed">
              "Respect your neighbors. Share accurate information. Keep the soul of Bucharest alive through positive and constructive contribution."
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default TermsPage;
